import { Component, OnInit } from '@angular/core';
import { UtilService } from '../../services/util.service';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css'],
})
export class SpinnerComponent implements OnInit {
    constructor(public _util: UtilService) {}

    ngOnInit(): void {}

    get display(): any {
        return {
            display: this._util.displaySpinner ? 'block' : 'none',
        };
    }
}
